const ROLES = {
    'Admin': "Partner",
    'Staff': "PartnerEmployee"
}

export const authRoles = {
    admin: [ROLES.SuperAdmin, ROLES.Admin],
    staff: [ROLES.SuperAdmin, ROLES.Admin, ROLES.Staff],
}
